// extracted by mini-css-extract-plugin
module.exports = {"spinNormalize":"general_spinNormalize__2lW6L"};